import React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import logo from './loginLogo.png';

function Logo() {
  return (
    <Card
      sx={{
        maxWidth: 345,
        border: 'none',
        boxShadow: 'none',
        margin: ' 0 auto',
        padding: 5,
      }}
    >
      <img
        className='multiPic'
        style={{
          minWidth: '250px',
          maxWidth: '250px',
          maxHeight: '100%',
          padding: '2px',
        }}
        src={logo}
        alt='logo'
      />

      {/* <CardMedia
        component="img"
        height="auto"
        width="auto"
        image={logo}
        alt="Multilayer Logo"
      /> */}
    </Card>
  );
}

export default Logo;
